import React, { useEffect, useState } from 'react';

import { Image } from 'antd';
import styled from 'styled-components';

import { getFileExtension, getFilename, isImageFile, isPDFFile } from 'utils/helpers/files';

import { THUMBNAIL_DEFAULT_HEIGHT, THUMBNAIL_DEFAULT_WIDTH } from './constants';
import PdfThumbnail from './PDFThumbnail';
import PreviewUnavailable from '../../common/PreviewUnavailable';

const Container = styled.a`
  display: block;
  overflow: hidden;
  background: var(--white);

  canvas,
  img,
  .ant-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

type FileItem = {
  file_name: string;
  file_url: string;
};

type Props = {
  file: FileItem;
  width?: number;
  height?: number;
};

const BrochureAndDocsThumbnails = ({
  file,
  width = THUMBNAIL_DEFAULT_WIDTH,
  height = THUMBNAIL_DEFAULT_HEIGHT,
}: Props) => {
  const [isPDF, setIsPDF] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const fileName = file.file_name || getFilename(file.file_url);
    const fileExtension = getFileExtension(fileName);
    const isFilePDF = isPDFFile(fileExtension);
    const isFileImage = isImageFile(fileExtension);

    setIsPDF(isFilePDF);
    setIsImage(isFileImage);
    setShowError(!isFilePDF && !isFileImage);
  }, [file]);

  return (
    <Container href={file.file_url} target="_blank" rel="noopener noreferrer" style={{ width, height }}>
      {isPDF && !showError && (
        <PdfThumbnail fileUrl={file.file_url} width={width} height={height} onError={setShowError} />
      )}
      {isImage && !showError && (
        <Image
          src={file.file_url}
          style={{ objectFit: 'cover' }}
          alt="img"
          height={height}
          width={width}
          preview={false}
          onError={() => {
            setShowError(true);
          }}
        />
      )}
      {showError && <PreviewUnavailable />}
    </Container>
  );
};

export default BrochureAndDocsThumbnails;
